import { render, staticRenderFns } from "./DataAnalysisDashboardViewPage.vue?vue&type=template&id=67acb2a7"
import script from "./DataAnalysisDashboardViewPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports